export class User {
	id: string;
	firstName: string;
	lastName: string;
	company: string;
	email: string;
	phone: string;
}
